import { action, atom } from '@reatom/framework'
import i18next from 'i18next'

import { AsyncStateN, pipe, Result } from '@blade/std-lib'
import { User, userReceivedAction } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { showSnackbarAction } from '@root/shared/ui-kit'

import type { Error } from '@root/shared'

export const removeSessionRequestAction = action(
  async (ctx, { ip }: { ip: string }) => {
    const {
      tradeApiClient,
      environment: {
        assets: { avatarsHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userSessionDelete, [{ ip: ip }]),
    )
    const mappedResult = pipe(
      result,
      Result.map((it) => User.fromDto(it, avatarsHost)),
      Result.mapError(ApiError.fallbackToUnknown),
    )
    return mappedResult
  },
  'removeSessionRequestAction',
)

export const removeSessionReatom = (ip: string) => {
  const removeRequestStateAtom = atom(
    AsyncStateN.notInitiated<Error.UnknownError, unknown>(),
    'removeRequestStateAtom',
  )

  const removeSessionAction = action(async (ctx) => {
    removeRequestStateAtom(ctx, AsyncStateN.loading())
    const result = await ctx.schedule(() =>
      removeSessionRequestAction(ctx, { ip: ip }),
    )

    if (Result.isSuccess(result)) {
      userReceivedAction(ctx, result.success)
      showSnackbarAction(ctx, {
        text: i18next.t('session.delete-session-success'),
        intent: 'success',
      })
    } else {
      showSnackbarAction(ctx, {
        text: i18next.t('session.delete-session-error'),
        intent: 'error',
      })
    }

    removeRequestStateAtom(ctx, AsyncStateN.fromResult(result))
  }, 'removeSessionAction')

  return {
    removeRequestStateAtom,
    removeSessionAction,
  }
}
